import React, { Component } from "react";
import DocumentTitle from "react-document-title";
// import { apiDefine } from "../../api/web";
// import { parseQuery } from "../../utils/tools";
import UA from "../../utils/ua";

import "./style.less";
const pic = 'https://oss.aircourses.com/web/client/outline/p2.png';

class CourseOutline2Page extends Component {
  render() {
    return (
      <DocumentTitle title={'课程大纲'}>
        <React.Fragment>
          <div className={`courseoutline ${ UA.mobileClient ? '' : 'pc'}`}>
              <img src={pic} alt="outline"/>
          </div>
        </React.Fragment>
      </DocumentTitle>
    );
  }
}

export default CourseOutline2Page;



// WEBPACK FOOTER //
// ./src/components/courseOutlinePage/courseOutline2Page.jsx